export class BalanceHistoryToken {
  static IBalanceHistoryRepository = Symbol("IBalanceHistoryRepository");
  static BalanceHistoryViewModel = Symbol("BalanceHistoryViewModel");
  static BalanceHistoryUseCase = Symbol("BalanceHistoryUseCase");
}
